import React, { useMemo, useState } from 'react';

const ASEGURADORAS = [
  'CHUBB SEGUROS MEXICO / CHUBB SEGUROS MEXICO',
  'Multiasistencia',
  'MAPFRE TEPEYAC, S.A. / MAPFRE TEPEYAC, S.A.',
  'Allianz México, S.A. Compañía de Seguros / Allianz México, S.A. Compañía de Seguros',
  'SEGUROS SURA / SEGUROS SURA',
  'QUALITAS / XNUUP'
];

const INITIAL_FORM = {
  aseguradora: 'CHUBB SEGUROS MEXICO / CHUBB SEGUROS MEXICO',
  cotizacion: '',
  pedido: '',
  fechaPedido: '',
  promesaEntrega: '',
  siniestro: '',
  localidadId: '',
  ciudadTaller: '',
  estadoTaller: '',
  nombreContacto: '',
  telefono: '',
  email: '',
  armadora: '',
  modelo: '',
  anio: '',
  item: '',
  origen: 'ORIGINAL',
  precio: '',
  oc: ''
};

const TEXT_FIELDS = [
  ['cotizacion', 'COTIZACION'],
  ['pedido', 'PEDIDO / VALE *'],
  ['siniestro', 'SINIESTRO *'],
  ['ciudadTaller', 'CIUDAD TALLER *'],
  ['estadoTaller', 'ESTADO TALLER *'],
  ['nombreContacto', 'NOMBRE CONTACTO'],
  ['telefono', 'TELEFONO'],
  ['email', 'EMAIL'],
  ['armadora', 'ARMADORA *'],
  ['modelo', 'MODELO *'],
  ['anio', 'AÑO *'],
  ['item', 'ITEM / PIEZA *'],
  ['precio', 'PRECIO *'],
  ['oc', 'OC']
];

const ValeManualForm = ({ visible, localidadesRows, guardando, onSubmit, onClose }) => {
  const [form, setForm] = useState(INITIAL_FORM);

  const localidades = useMemo(
    () => Array.isArray(localidadesRows) ? localidadesRows : [],
    [localidadesRows]
  );

  if (!visible) return null;

  const update = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  const resetAndClose = () => {
    setForm(INITIAL_FORM);
    onClose();
  };

  const handleSubmit = async () => {
    const localidadSeleccionada = localidades.find(loc => String(loc.id) === String(form.localidadId));
    const faltantes = [];

    if (!form.aseguradora.trim()) faltantes.push('ASEGURADORA');
    if (!form.pedido.trim()) faltantes.push('PEDIDO / VALE');
    if (!form.fechaPedido.trim()) faltantes.push('FECHA PEDIDO');
    if (!form.siniestro.trim()) faltantes.push('SINIESTRO');
    if (!localidadSeleccionada) faltantes.push('TALLER / LOCALIDAD');
    if (!form.ciudadTaller.trim()) faltantes.push('CIUDAD TALLER');
    if (!form.estadoTaller.trim()) faltantes.push('ESTADO TALLER');
    if (!form.armadora.trim()) faltantes.push('ARMADORA');
    if (!form.modelo.trim()) faltantes.push('MODELO');
    if (!form.anio.trim()) faltantes.push('AÑO');
    if (!form.item.trim()) faltantes.push('ITEM / PIEZA');
    if (!form.origen.trim()) faltantes.push('ORIGEN');
    if (!form.precio.trim()) faltantes.push('PRECIO');

    if (faltantes.length > 0) {
      alert(`Faltan campos obligatorios:\n- ${faltantes.join('\n- ')}`);
      return;
    }

    if (!window.confirm('¿Enviar este vale manual a Codificar?')) return;

    const ok = await onSubmit(form, localidadSeleccionada);
    if (ok !== false) {
      setForm(INITIAL_FORM);
    }
  };

  return (
    <div className="section-card" style={{ marginBottom: 12 }}>
      <h3 style={{ marginTop: 0 }}>Capturar VALE MANUAL</h3>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 12 }}>
        <label>
          ASEGURADORA *
          <select className="input-control" value={form.aseguradora} onChange={e => update('aseguradora', e.target.value)}>
            {ASEGURADORAS.map(opcion => (
              <option key={opcion} value={opcion}>{opcion}</option>
            ))}
          </select>
        </label>

        <label>
          FECHA PEDIDO *
          <input className="input-control" type="date" value={form.fechaPedido} onChange={e => update('fechaPedido', e.target.value)} />
        </label>

        <label>
          PROMESA DE ENTREGA
          <input className="input-control" type="date" value={form.promesaEntrega} onChange={e => update('promesaEntrega', e.target.value)} />
        </label>

        <label>
          TALLER / LOCALIDAD *
          <select className="input-control" value={form.localidadId} onChange={e => update('localidadId', e.target.value)}>
            <option value="">Selecciona taller exacto...</option>
            {localidades.map(loc => (
              <option key={loc.id} value={String(loc.id)}>
                {loc.taller} — {loc.localidad}{loc.codigo ? ` — ${loc.codigo}` : ''}
              </option>
            ))}
          </select>
        </label>

        {TEXT_FIELDS.map(([field, label]) => (
          <label key={field}>
            {label}
            <input
              className="input-control"
              value={form[field]}
              onChange={e => update(field, e.target.value)}
            />
          </label>
        ))}

        <label>
          ORIGEN *
          <select className="input-control" value={form.origen} onChange={e => update('origen', e.target.value)}>
            <option value="ORIGINAL">ORIGINAL</option>
            <option value="USADO">USADO</option>
            <option value="ALTERNATIVO">ALTERNATIVO</option>
          </select>
        </label>
      </div>

      <div className="action-controls" style={{ marginTop: 12 }}>
        <button type="button" className="btn btn-primary" onClick={handleSubmit} disabled={guardando}>
          {guardando ? 'Guardando...' : 'Enviar renglón'}
        </button>
        <button type="button" className="btn btn-secondary" onClick={resetAndClose}>
          Cancelar
        </button>
      </div>
    </div>
  );
};

export default ValeManualForm;
